import './scss/index.scss';
import { dcFactory } from 'dc';
import { AccountDetailsFormComponent } from './js/account-details-form.component';

dcFactory.register(AccountDetailsFormComponent);
